module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": true
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.params.id ? '编辑门店' : '新增门店'))])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "detail-cont"
  }, [_c('div', {
    staticClass: "fx fx-y-center"
  }, [_vm._m(0), _vm._v(" "), _c('z-upload', {
    attrs: {
      "file-url": _vm.params.logo_url,
      "on-success": _vm.handleUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pic-tips m-l-10"
  }, [_vm._v("建议尺寸：200*200")])], 1), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "maxlength": "20",
      "title": "门店名称",
      "isMust": "true"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.name"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "type": "email",
      "maxlength": "11",
      "title": "手机号",
      "isMust": "true"
    },
    model: {
      value: (_vm.params.tel),
      callback: function($$v) {
        _vm.$set(_vm.params, "tel", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.tel"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "title": "门店位置-经度",
      "placeholder": "如：103.4664916992",
      "isMust": "true"
    },
    model: {
      value: (_vm.params.longitude),
      callback: function($$v) {
        _vm.$set(_vm.params, "longitude", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.longitude"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "title": "门店位置-纬度",
      "placeholder": "如：39.3911013341",
      "isMust": "true"
    },
    model: {
      value: (_vm.params.latitude),
      callback: function($$v) {
        _vm.$set(_vm.params, "latitude", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.latitude"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "title": "门店地址",
      "isMust": "true"
    },
    model: {
      value: (_vm.params.address),
      callback: function($$v) {
        _vm.$set(_vm.params, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.address"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "title": "语音设备编号"
    },
    model: {
      value: (_vm.params.device_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "device_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.device_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 fx btn-adaption"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleAddBtn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("门店logo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-10 c-g fx shop-tips"
  }, [_c('p', {
    staticClass: "w120 m-r-5"
  }), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tTips：经度是大于纬度的哟！经纬度获取地址：\n\t\t\t\t\t"), _c('a', {
    staticClass: "link-style",
    attrs: {
      "href": "http://www.gpsspg.com/maps.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.gpsspg.com/maps.htm")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-19e1891b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/shops/ShopEdit.vue
// module id = 821
// module chunks = 0